import React, { useEffect, useState } from 'react';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0B1C2C]/95 backdrop-blur-md shadow-lg shadow-black/20 border-b border-[#2F6BFF]/10' : 'bg-transparent'}`} data-id="element-108">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-109">
        <div className="flex items-center justify-between h-14 sm:h-16" data-id="element-110">
          {/* Left — Title */}
          <a href="#" onClick={e => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="text-[#F2F4F8] font-bold text-sm sm:text-lg truncate mr-3 sm:mr-4 flex-shrink min-w-0" data-id="element-111">
            <span className="hidden sm:inline" data-id="element-112">
              📖 El Manual Prohibido de la Creatina
            </span>
            <span className="sm:hidden" data-id="element-113">📖 Manual Creatina</span>
          </a>

          {/* Right — Nav (always visible) */}
          <nav className="flex items-center gap-2 sm:gap-6 flex-shrink-0" data-id="element-114">
            <a href="#bonos" onClick={e => {
            e.preventDefault();
            handleClick('#bonos');
          }} className="text-[#F2F4F8]/70 active:text-[#F2F4F8] hover:text-[#F2F4F8] font-medium text-xs sm:text-sm transition-colors duration-200 py-2 px-1 sm:px-2" data-id="element-115">
              Bonos
            </a>
            <a href="#testimonios" onClick={e => {
            e.preventDefault();
            handleClick('#testimonios');
          }} className="text-[#F2F4F8]/70 active:text-[#F2F4F8] hover:text-[#F2F4F8] font-medium text-xs sm:text-sm transition-colors duration-200 py-2 px-1 sm:px-2" data-id="element-116">
              Testimonios
            </a>
            <a href="#comprar" onClick={e => {
            e.preventDefault();
            handleClick('#comprar');
          }} className="bg-[#2F6BFF] active:bg-[#1A4AD4] hover:bg-[#1F54D8] text-white font-bold text-xs sm:text-sm px-3 sm:px-6 py-2 sm:py-2.5 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/30 whitespace-nowrap" data-id="element-117">
              Comprar AHORA
            </a>
          </nav>
        </div>
      </div>
    </header>;
}